import { Button, Divider, Typography } from "@mui/material";
import MenuRearrange from "./MenuRearrange";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
const Rearrange = () => {
  const navigate = useNavigate()
  const handleGoBack = ()=>{
    navigate(-1)
  }
  return (
    <div className="p-3">
      <div className="py-3 flex justify-between">
        <Typography variant="h6">Rearrange Menu</Typography>
        <Button color="error" startIcon={<ArrowBackIcon/>} onClick={handleGoBack}>back</Button>
      </div>
      <Divider />
      <MenuRearrange />
    </div>
  );
};

export default Rearrange;
